/**
 * BaigLabs parent portfolio — products and platforms under the BaigLabs brand.
 * Used by the anonymous landing and the logged-in launchpad.
 *
 * `external` — open in a new tab (other origin).
 * `spa` — same-origin React route (use the client router).
 * Everything else is a path nginx proxies to a sibling app; use a full page load.
 */

/**
 * InterviewFlow / Public Sector are a separate brand (interviewflow.studio).
 * Never list them on BaigLabs marketing or signed-in launchpad product grids.
 */
export const BAIGLABS_AUTH_ONLY_PRODUCT_IDS = new Set();

export const BAIGLABS_PRODUCTS = [
  {
    id: 'hisetsuccess',
    name: 'HiSET Success',
    tagline: 'Prep and practice for the HiSET exam.',
    href: 'https://hisetsuccess.org',
    external: true,
  },
  {
    id: 'vectorbridge',
    name: 'VectorBridge',
    tagline: 'Connect and work with vector search and knowledge.',
    href: '/silicon/',
    external: false,
  },
  {
    id: 'tadabbur',
    name: 'Tadabbur',
    tagline: 'Reflective reading and study experiences.',
    href: '/apps/tadabbur',
    external: false,
    spa: true,
  },
  {
    id: 'deen',
    name: 'Deen Companion',
    tagline: 'Daily guidance and learning on the go.',
    href: '/apps/deen-companion',
    external: false,
    spa: true,
  },
  {
    id: 'workouts',
    name: 'Standup Workouts',
    tagline: 'Short desk fitness breaks anywhere.',
    href: '/apps/standup-workouts',
    external: false,
    spa: true,
  },
  {
    id: 'studio',
    name: 'BaigLabs Studio',
    tagline: 'Build chats, forms, and agentic flows in one workspace.',
    href: '/signin',
    external: false,
    spa: true,
  },
];

/** Studio tile: sign-in on the marketing page, home dashboard when already signed in. */
export function studioProductHref({ signedIn = false } = {}) {
  return signedIn ? '/dashboard' : '/signin';
}

export function productsForSurface({ signedIn = false } = {}) {
  return BAIGLABS_PRODUCTS
    .filter((p) => signedIn || !BAIGLABS_AUTH_ONLY_PRODUCT_IDS.has(p.id))
    .map((p) => {
      let next = p;
      if (p.id === 'studio') {
        next = { ...p, href: studioProductHref({ signedIn }) };
      } else if (signedIn && p.taglineSignedIn) {
        next = { ...p, tagline: p.taglineSignedIn };
      }
      return next;
    });
}

/** Open a portfolio product: new tab, SPA route, or full navigation for nginx-mounted apps. */
export function openBaiglabsProduct(product, navigate) {
  if (!product?.href) return;
  if (product.external) {
    window.open(product.href, '_blank', 'noopener,noreferrer');
    return;
  }
  if (product.spa && typeof navigate === 'function') {
    navigate(product.href);
    return;
  }
  window.location.assign(product.href);
}
